import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type PromocodeItemDraft as SchemaPromocodeItemDraft } from '../schemas/PromocodeItemDraft';
import { type PromocodeItemWriteResponse as SchemaPromocodeItemWriteResponse } from '../schemas/PromocodeItemWriteResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Создает новый промокод в указанной группе
 * @tags PromocodeGroups
 * @summary Создание нового промокода в группе
 */
export const PromocodeGroupPromocodeCreateContentType = 'application/json' as const;
export type PromocodeGroupPromocodeCreateRequest = SchemaPromocodeItemDraft;
export type PromocodeGroupPromocodeCreateResponses = LinkCommonErrorResponses & {
    /**
     * @description Запрос обработан
     */
    '200': {
        'application/json': SchemaPromocodeItemWriteResponse;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupPromocodeCreateResponseSuccess =
    PromocodeGroupPromocodeCreateResponses['200']['application/json'];
export type PromocodeGroupPromocodeCreateSearchParams = undefined;
export type PromocodeGroupPromocodeCreatePathParameters = {
    group_id: string;
};
export const PromocodeGroupPromocodeCreateUrl = '/promocode_groups/{group_id}/promocodes' as const;
export const PromocodeGroupPromocodeCreateMethod = 'POST' as const;
export const getPromocodeGroupPromocodeCreateUrl = (params: PromocodeGroupPromocodeCreatePathParameters) =>
    PromocodeGroupPromocodeCreateUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof PromocodeGroupPromocodeCreatePathParameters) => String(params[param])
    );
